/**
 * Generated by the safari control rack.
 *
 * The @piece block below is the panel's round-trip format. Edit the component
 * freely; as long as that block survives, the rack can reopen this file.
 */
/* @piece
{
  "seed": 27201,
  "clock": {
    "rate": 0.05,
    "phase": 0,
    "loop": 0
  },
  "frame": {
    "zoom": 1,
    "rotation": 0,
    "orbit": 0,
    "tilt": 0,
    "perspective": 0,
    "wobble": 0,
    "breathe": 0,
    "vignette": 0,
    "groundHue": 0,
    "groundSaturation": 0.02,
    "groundLightness": 0
  },
  "pointer": {
    "path": "field.falloff",
    "amount": 0.35,
    "jitter": 0.6
  },
  "layers": [
    {
      "enabled": true,
      "timeScale": 1,
      "phaseOffset": 0,
      "field": {
        "type": "interference",
        "sources": 4,
        "frequency": 0.7,
        "amplitude": 0.9,
        "falloff": 0.5,
        "drift": 2,
        "travel": 0
      },
      "substrate": {
        "type": "column",
        "rings": 34,
        "around": 9,
        "spin": 0.04,
        "bulge": 0.42,
        "taper": 0.3,
        "jitter": 0
      },
      "motion": {
        "displace": 0,
        "shift": -0.19,
        "axis": "radial",
        "align": "flow",
        "twist": 1,
        "spin": 0
      },
      "mark": {
        "geometry": "dot",
        "scale": 0.45,
        "sides": 4,
        "turn": 0,
        "glyphMode": "sign",
        "glyphs": "/\\|"
      },
      "ink": {
        "gain": 2.2,
        "weight": 2.6,
        "bands": 2.5,
        "invert": 0.28,
        "opacity": 1,
        "hue": 73,
        "saturation": 1,
        "lightness": 0.98,
        "persistence": 0.95
      },
      "transform": {
        "scale": 1,
        "x": 0,
        "y": 0,
        "rotation": 0,
        "spin": 0
      }
    }
  ]
}
*/
import Visualization from '../../vendor/skargard/react/Visualization.jsx'

// interference field, sampled on a column substrate,
// drawn as dot marks. Frame is free-running.
const piece = {
  "seed": 27201,
  "clock": {
    "rate": 0.05,
    "phase": 0,
    "loop": 0
  },
  "frame": {
    "zoom": 1,
    "rotation": 0,
    "orbit": 0,
    "tilt": 0,
    "perspective": 0,
    "wobble": 0,
    "breathe": 0,
    "vignette": 0,
    "groundHue": 0,
    "groundSaturation": 0.02,
    "groundLightness": 0
  },
  "pointer": {
    "path": "field.falloff",
    "amount": 0.35,
    "jitter": 0.6
  },
  "layers": [
    {
      "enabled": true,
      "timeScale": 1,
      "phaseOffset": 0,
      "field": {
        "type": "interference",
        "sources": 4,
        "frequency": 0.7,
        "amplitude": 0.9,
        "falloff": 0.5,
        "drift": 2,
        "travel": 0
      },
      "substrate": {
        "type": "column",
        "rings": 34,
        "around": 9,
        "spin": 0.04,
        "bulge": 0.42,
        "taper": 0.3,
        "jitter": 0
      },
      "motion": {
        "displace": 0,
        "shift": -0.19,
        "axis": "radial",
        "align": "flow",
        "twist": 1,
        "spin": 0
      },
      "mark": {
        "geometry": "dot",
        "scale": 0.45,
        "sides": 4,
        "turn": 0,
        "glyphMode": "sign",
        "glyphs": "/\\|"
      },
      "ink": {
        "gain": 2.2,
        "weight": 2.6,
        "bands": 2.5,
        "invert": 0.28,
        "opacity": 1,
        "hue": 73,
        "saturation": 1,
        "lightness": 0.98,
        "persistence": 0.95
      },
      "transform": {
        "scale": 1,
        "x": 0,
        "y": 0,
        "rotation": 0,
        "spin": 0
      }
    }
  ]
}

export default function ValleySpirit() {
  return <Visualization piece={piece} />
}

ValleySpirit.piece = piece

